(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    var community = document.querySelector('.seyune-edit-community');
    if (!community || community.dataset.ready === 'true') return;
    community.dataset.ready = 'true';

    var focusButton = community.querySelector('[data-seyune-comment-focus]');
    var commentForm = community.querySelector('#seyune-edit-comment-form');

    if (focusButton && commentForm) {
      focusButton.addEventListener('click', function () {
        commentForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var firstField = commentForm.querySelector('input, textarea');
        if (firstField) window.setTimeout(function () { firstField.focus({ preventScroll: true }); }, 350);
      });
    }
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
